import React from 'react';
import './loader.css'

const LoaderSm = () => {
    return (
        <div className='row g-5 mx-2'>
            <div className="col-md-4">
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
            </div>
            <div className="col-md-4 ">
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
            </div>
            <div className="col-md-4">
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
            </div>
            <div className="col-md-4">
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
                <div className="animated-background w-75" ></div>
            </div>
        </div>
    );
};

export default LoaderSm;